import { findLeafNode } from '../../utils/tree'

export default {
  render (h) {
    return (
      <div class={this.showMenu ? 'show' : ''}>
        <div
          class="close sp-hidden-pc"
          on-click={() => {
            this.showMenuFlag = !this.showMenuFlag
            document.body.style.overflow = this.showMenuFlag ? 'hidden' : 'visible'
          }}
        >
          <i class="el-icon-more"></i>
        </div>
        {this.$slots.default}
        <el-menu
          defaultActive={this.isMobile ? null : this.getActiveMenu()}
          uniqueOpened
          backgroundColor="var(--bg-color)"
          textColor="var(--text-color-light)"
          activeTextColor="var(--text-color-light)"
        >
          {this.getChildren(this.data)}
        </el-menu>
      </div>
    )
  },
  props: {
    data: Array
  },
  data() {
    return {
      showMenuFlag: false
    }
  },
  computed: {
    isMobile() {
      return /(android|ios|phone|mobile)/i.test(navigator.userAgent)
    },
    showMenu() {
      return !this.isMobile || this.showMenuFlag
    }
  },
  methods: {
    getActiveMenu() {
      return findLeafNode(this.data, this.$route.path)
    },
    getMenuContent(item) {
      return [(
        <div slot="title">
          <icon
            class="title-icon"
            name={item['fa-icon'] && item['fa-icon'].indexOf('fa') !== -1 ? item['fa-icon'].split('fa-')[1] : item['fa-icon']}
          />
          <span>{this.$i18n(item.title)}</span>
        </div>
      )]
    },
    getChildren(arr) {
      const children = []
      if (arr && arr.length) {
        arr.forEach(item => {
          if (item.children && item.children.length) {
            children.push(
              <el-submenu index={item.id.toString()}>
                {this.getMenuContent(item)}
                {this.getChildren(item.children)}
              </el-submenu>
            )
          } else {
            children.push(
              <el-menu-item
                index={item.id.toString()}
                on-click={() => {
                  location.href = item.url
                  this.showMenuFlag = false
                }}
              >
                {this.getMenuContent(item)}
                {this.getChildren(item.children)}
              </el-menu-item>
            )
          }
        })
      }
      return children
    }
  }
}



// WEBPACK FOOTER //
// ./packages/components/Menu/index.js